<template>
  <session class="mobile-page-plan" ref="scrollTarget">
    <Header />
    <div class="plan-block1" :style="{ backgroundImage: `url(${block1Cover})` }">
      <div class="plan-block plan-block1-l">
        <Icon :name="({ person: 'gerenbaozhang-white', unit: 'jigoubaozhang-white' })[mode]" size="40" />
        <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{block1Title}}</div>
        <div class="desc">{{block1Desc}}</div>
        <div class="btns">
          <div class="item primary" @click="Utils.loginDialogToggle(true,mode)"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Btn1 }}</span></div>
          <!-- <div class="item"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{block1Btn2}}</span></div> -->
        </div>
      </div>
    </div>
    
    <div class="plan-block plan-block2">
      <div class="block-header">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
        <span />
      </div>
      <div class="block-body">
        <div class="category">
          <div class="item" v-for="(item, index) in block2Category" :key="index">
            <div class="order">{{ item?.order }}</div>
            <div class="name">{{ item?.name }}</div>
            <div class="iconwrap"><Icon :name="item?.icon" size="32" /></div>
          </div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in block2List" :key="index">
            <div class="title">
              <Icon :name="item?.icon" />
              <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span>
            </div>
            <div class="desc" :class="{ en: getLocalLangCode() != 'zh' }">{{ item?.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="plan-block plan-block3">
      <div class="block-header">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block3Title }}</span>
        <span />
      </div>
      <div class="block-body">
        <div class="list">
          <div class="item" v-for="(item, index) in block3List" :key="index">
            
            <div class="title"><Icon :name="item?.icon" size="24" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span></div>
            <div class="desc">{{ item?.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="moreinfo-block">
      <div class="moreinfo-h">
        <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ moreinfoTitle }}</div>
        <div class="desc">{{ moreinfoDesc }}</div>
        <div class="contactbtn" @click="Utils.toTargetPage('/contactus')">
          <Icon name="chat" size="16" />
          <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ moreinfoContact }}</span>
        </div>
      </div>
      <!-- <div class="slogan" v-html="Utils.presetHtmlText(moreinfoSlogan)" /> -->
      <div class="noresponse">
        <span class="title">{{ moreinfoNoResponse?.title }}</span>
        <span class="content">{{ moreinfoNoResponse?.content }}</span>
      </div>
    </div>

    <Footer />

    <div class="bottom-btns" :class="{ show: !!showBottomBtns }">
      <div class="btnitem primary" @click="Utils.loginDialogToggle(true,mode)"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('plan_btn_applynow')}}</span></div>
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Banner from '@/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/mobile/components/footer/index.vue';
  import Header from '@/mobile/components/header/index.vue';
  import { useRouter, useRoute } from 'vue-router';
  const route = useRoute();

  import IMG_COVER_PERSON from './images/person.png';
  import IMG_COVER_UNIT from './images/unit.png';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  const mode = route.params?.target;  // person | unit
  console.log('route.params--', route.params, 'mode', mode)

  //术前意外保障计划
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1Btn1 = ref('');
  const block1Btn2 = ref('');
  const block1Cover = ref(null);
  const block1Init = () => {
    if(mode == 'person') {
      block1Title.value = LOCAL('plan_person');
      block1Desc.value = LOCAL('plan_person_desc');
      block1Btn1.value = LOCAL('plan_btn_applynow');
      block1Btn2.value = LOCAL('plan_btn_manual');
      block1Cover.value = IMG_COVER_PERSON
    }
    if(mode == 'unit') {
      block1Title.value = LOCAL('plan_unit');
      block1Desc.value = LOCAL('plan_unit_desc');
      block1Btn1.value = LOCAL('plan_btn_applynow');
      block1Btn2.value = LOCAL('plan_btn_manual');
      block1Cover.value = IMG_COVER_UNIT
    }
  }
  onMounted(() => {
    block1Init()
  });

  //保障范围
  const block2Title = ref('');
  const block2Category = ref([]);
  const block2List = ref([]);
  const block2Init = () => {
    block2Title.value = LOCAL('plan_coverage');
    block2Category.value = [
      { order: '01', name: LOCAL('plan_coverage_1'), icon: 'face' },
      { order: '02', name: LOCAL('plan_coverage_2'), icon: 'nose' },
      { order: '03', name: LOCAL('plan_coverage_3'), icon: 'eyes' },
      { order: '04', name: LOCAL('plan_coverage_4'), icon: 'boobs' },
      { order: '05', name: LOCAL('plan_coverage_5'), icon: 'fat' },
    ]
    if(mode == 'person') {
      block2List.value = [
        { title: LOCAL('plan_person_coverage_list_1_title'), desc: LOCAL('plan_person_coverage_list_1_desc'), icon: 'yiwaishenwang' },
        { title: LOCAL('plan_person_coverage_list_2_title'), desc: LOCAL('plan_person_coverage_list_2_desc'), icon: 'gongnengxingsunshang' },
        { title: LOCAL('plan_person_coverage_list_3_title'), desc: LOCAL('plan_person_coverage_list_3_desc'), icon: 'shoushushigu' },
        { title: LOCAL('plan_person_coverage_list_4_title'), desc: LOCAL('plan_person_coverage_list_4_desc'), icon: 'lianghuamanyidu' },
      ]
    }

    if(mode == 'unit') {
      block2List.value = [
        { title: LOCAL('plan_unit_coverage_list_1_title'), desc: LOCAL('plan_unit_coverage_list_1_desc'), icon: 'yiwaishenwang' },
        { title: LOCAL('plan_unit_coverage_list_2_title'), desc: LOCAL('plan_unit_coverage_list_2_desc'), icon: 'gongnengxingsunshang' },
        { title: LOCAL('plan_unit_coverage_list_3_title'), desc: LOCAL('plan_unit_coverage_list_3_desc'), icon: 'shoushushigu' },
        { title: LOCAL('plan_unit_coverage_list_4_title'), desc: LOCAL('plan_unit_coverage_list_4_desc'), icon: 'lianghuamanyidu' },
      ]
    }
  }
  onMounted(() => {
    block2Init()
  });

  //计划特色
  const block3Title = ref('');
  const block3List = ref([]);
  const block3Init = () => {
    block3Title.value = LOCAL('plan_features');
    if(mode == 'person') {
      block3List.value = [
        { title: LOCAL('plan_person_features_1_title'), desc: LOCAL('plan_person_features_1_desc'), icon: 'fast' },
        { title: LOCAL('plan_person_features_2_title'), desc: LOCAL('plan_person_features_2_desc'), icon: 'vip' },
        { title: LOCAL('plan_person_features_3_title'), desc: LOCAL('plan_person_features_3_desc'), icon: 'keshihuabaodan' },
        { title: LOCAL('plan_person_features_4_title'), desc: LOCAL('plan_person_features_4_desc'), icon: 'haiwaiyiliao' },
      ]
    }
    if(mode == 'unit') {
      block3List.value = [
        { title: LOCAL('plan_unit_features_1_title'), desc: LOCAL('plan_unit_features_1_desc'), icon: 'fast' },
        { title: LOCAL('plan_unit_features_2_title'), desc: LOCAL('plan_unit_features_2_desc'), icon: 'tishengzonghebeishu' },
        { title: LOCAL('plan_unit_features_3_title'), desc: LOCAL('plan_unit_features_3_desc'), icon: 'zhuanyiyewufengxian' },
        { title: LOCAL('plan_unit_features_4_title'), desc: LOCAL('plan_unit_features_4_desc'), icon: 'vip' },
      ]
    }
  }
  onMounted(() => {
    block3Init()
  });

  //更多资讯
  const moreinfoTitle = ref('');
  const moreinfoDesc = ref('');
  const moreinfoContact = ref('');
  const moreinfoSlogan = ref('');
  const moreinfoNoResponse = ref({ title: '', content: '' });
  const moreinfoInit = () => {
    moreinfoTitle.value = LOCAL('plan_moreinfo');
    moreinfoDesc.value = LOCAL('plan_moreinfo_desc');
    moreinfoContact.value = LOCAL('contactUs');
    moreinfoSlogan.value = LOCAL('plan_moreinfo_slogan');
    moreinfoNoResponse.value = {
      title: LOCAL('plan_moreinfo_nores'),
      content: LOCAL('plan_moreinfo_nores_desc'),
    }
  }
  onMounted(() => {
    moreinfoInit()
  });

  const scrollTarget = ref(null);
  const showBottomBtns = ref(false);
  const scrollHandle = (event) => {
    const scrollTop = window.scrollY;
    console.log('scrollTop---',scrollTop, window.scrollY);
    if(scrollTop > 308) {
      showBottomBtns.value = true;
    }else{
      showBottomBtns.value = false;
    }
  }
  onMounted(() => {
    window.addEventListener('scroll', scrollHandle, true);
  });
  onUnmounted(() => {
    window.removeEventListener('scroll', scrollHandle, true);
  })
</script>

<style scoped lang="less">
  @import "index.less";
</style>
